<template>
    <div>
        <div class="container" :style="{minHeight:minHeight + 'px'}">
            <Head msg="Welcome to Your Vue.js App"/>
            <img style="width:100%;height: 300px;" src="./../assets/image/back/huiyuanzhongxin_back.jpg" alt="">
            <div class="content">

                <h1 v-html="tableData.title" style="font-size:24px;padding:10px;"></h1>
                <h1 v-html="tableData.subtitle" style="font-size:18px;padding:10px;color:#555555"></h1>
                <!-- <el-collapse accordion style="width: 500px;border: none">
                    <el-collapse-item >
                        <template slot="title">
                            <span style="color: #0099E2; font-size: 16px">附件(点击后展开)<i class="header-icon el-icon-info"></i></span>
                        </template>
                        <div v-bind="accessoryList" v-for="(item) in accessoryList" :key="item" style="width:500px;">
                            <img style="display: none;" src="../assets/image/accessory.png" class="accessory-img"><p @click="handleOpenUrl(item.uri)" style="cursor:pointer;color: #0099E2;">{{item.name}}</p><br/>
                        </div>
                    </el-collapse-item>
                </el-collapse> -->
                <div style="height:50px;"><p style="text-align:left;float:left;line-height:50px"
                                             v-if="tableData.classify">[{{tableData.classify}}]</p>
                    <p style="text-align:right;float:right;line-height:50px">
                        {{timestampToTime(tableData.uploadTime)}}</p></div>

                <p v-html="tableData.context"></p>
            </div>
        </div>
        <Footer msg="Welcome to Your Vue.js App"/>
    </div>
</template>

<script>
    // @ is an alias to /src
    //import HelloWorld from "@/components/HelloWorld.vue";
    import Head from "@/components/Head.vue";
    import Footer from "@/components/Footer.vue";
    import {articleById} from "@/api/article";

    export default {
        data() {
            return {
                tableData: "",
                accessoryList: [],
                minHeight: 0
            };
        },
        mounted() {
            this.minHeight = document.documentElement.clientHeight - 200;
            var me = this;
            window.onresize = function () {
                me.minHeight = document.documentElement.clientHeight - 200;
            };
            articleById(this.$route.params.id).then(res => {
                this.tableData = res;
                this.accessoryList = res.accessoryList;
            });
        },
        methods: {
            timestampToTime(timestamp) {
                const date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
                const Y = date.getFullYear() + '-';
                const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                const h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                const m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                const s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
                return Y + M + D + h + m + s;//时分秒可以根据自己的需求加上
            },handleOpenUrl(url){
                debugger
                window.open(url)
            }
        },
        components: {
            Head,
            Footer
        }
    };
</script>
<style lang="scss" scoped>
    .content {
        p {
            text-align: left;
            font-size: 16px;
            /* padding: 5px 0; */
            line-height: 35px;
            color: #404040;
            margin-top:-4px;

        }
        width: 1000px;
        margin: 20px auto;
    }
    .accessory-img {
        float: left;
        width: 20px;
        height: 22px;
        margin-right: 5px;
    }
</style>
